import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import VihsMark from '../../components/VihsMark';
import './NotFound.css';

const CONTACT_URL = 'https://discord.gg/ScdKWjtkVd';

export default function NotFound() {
  return (
    <main className="not-found">
      <div className="not-found-atmosphere" aria-hidden="true">
        <span className="not-found-glow" />
        <span className="not-found-grid" />
        <span className="not-found-orbit not-found-orbit-one" />
        <span className="not-found-orbit not-found-orbit-two" />
      </div>

      <header className="not-found-header">
        <Link to="/" className="not-found-logo" aria-label="Vih's — página inicial">
          <VihsMark />
          Vih&apos;s
        </Link>
        <span className="not-found-header-status">
          <i aria-hidden="true" />
          Sistema operacional
        </span>
      </header>

      <section className="not-found-content" aria-labelledby="not-found-title">
        <motion.div
          className="not-found-copy"
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="not-found-eyebrow">
            <span>Erro 404</span>
            Rota não encontrada
          </p>

          <h1 id="not-found-title">
            Você chegou a um lugar que <em>ainda não existe.</em>
          </h1>

          <p className="not-found-lead">
            O endereço pode ter mudado ou nunca ter feito parte do nosso ecossistema.
            Nada foi perdido — vamos colocar você de volta na rota certa.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="not-found-button not-found-button-primary">
              <FaArrowLeft aria-hidden="true" />
              Voltar ao início
            </Link>
            <a
              href={CONTACT_URL}
              className="not-found-button not-found-button-ghost"
              target="_blank"
              rel="noopener noreferrer"
            >
              Falar com a Vih&apos;s
              <FaArrowRight aria-hidden="true" />
            </a>
          </div>
        </motion.div>

        <motion.div
          className="not-found-visual"
          aria-hidden="true"
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="not-found-code">404</span>
          <div className="not-found-signal">
            <span className="not-found-signal-dot" />
            <span className="not-found-signal-line" />
            <span className="not-found-signal-label">Destino desconhecido</span>
          </div>
        </motion.div>
      </section>

      <footer className="not-found-footer">
        <span>Vih&apos;s © {new Date().getFullYear()}</span>
        <Link to="/termos">Termos e Políticas</Link>
        <span>Criação digital sob medida.</span>
      </footer>
    </main>
  );
}
